import { render } from "./HermesDashboard.vue?vue&type=template&id=0b2be394&scoped=true"
import script from "./HermesDashboard.vue?vue&type=script&lang=js"
export * from "./HermesDashboard.vue?vue&type=script&lang=js"

import "./HermesDashboard.vue?vue&type=style&index=0&id=0b2be394&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b2be394"]])

export default __exports__